import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

import { gsap } from "gsap";
import {Power4} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import slick from "slick-carousel/slick/slick";
import Inputmask from "../.../../../node_modules/inputmask/dist/jquery.inputmask.min";
import Lenis from '@studio-freight/lenis'
import 'ninelines-ua-parser';
import SplitType from 'split-type'


 $(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});


 const lenis = new Lenis()

lenis.on('scroll', (e) => {
//   console.log(e)
})

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)






gsap.registerPlugin(ScrollTrigger);





function initParallax() {
	// Получаем все элементы, которые будут двигаться
	const backgrounds = document.querySelectorAll('.parallax-bg');
      
	// Проверяем, существуют ли элементы
	backgrounds.forEach(bg => {
	  // Получаем значение смещения из data-атрибута
	  const depth = bg.getAttribute('data-parallax-depth') || '-50%'; // Значение по умолчанию, если атрибут не задан
      
	  // Создаем анимацию для каждого фона
	  gsap.to(bg, {
	    scrollTrigger: {
	      trigger: bg, // Элемент, относительно которого срабатывает триггер
	      start: "top bottom", // Начало анимации когда верх элемента достигает низа вьюпорта
	      end: "bottom top", // Конец анимации, когда низ элемента достигает верха вьюпорта
	      scrub: true // Плавное следование анимации за прокруткой
	    },
	    y: depth // Смещение элемента по оси Y, заданное в data-атрибуте
	  });
	});
      }
      
// Вызываем функцию инициализации после загрузки страницы
window.addEventListener('load', initParallax);







ScrollTrigger.matchMedia({
	"(min-width: 992px)" : function() {
		const splitWords= document.querySelectorAll('.reveal-words')
		splitWords.forEach((char,i) => {

			const bg = char.dataset.bgColor
			const fg = char.dataset.fgColor

			const text = new SplitType(char, { types: 'words'})

			gsap.fromTo(text.words, 
				{
					color: bg,
					y: -50,
					opacity: 0
				},
				{
					color: fg,
					duration: 0.3,
					stagger: 0.01,
					y: 0,
					opacity: 1,
					scrollTrigger: {
						trigger: char,
						start: 'top 80%',
						end: 'top 20%',
						scrub: true,
						markers: false,
						toggleActions: 'play play reverse reverse'
					}
				})
		})

		const text = new SplitType('.hero__title', { types: 'words, chars' })
		const text2 = new SplitType('.hero__subtitle', { types: 'words, chars' })


		const heroAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: ".hero",
				toggleActions: "play none none none",
				
			},
			repeat: 0,
			repeatDelay: 1,
			ease: Power4.easeIn
		}).eventCallback("onComplete", function() {
			document.body.classList.remove("noscroll");
		});



		// heroAnimation.to(".loadblock", {
		// 	duration: .2,
		// 	// display:"none",
		// 	delay: 2,
		// 	opacity: 0,
		// 	ease: "none"
		// 	//ease: "bounce"
		// })


		heroAnimation.to(".loader", {
			duration: .2,
			// display:"none",
			delay: 1.6,
			opacity: 0,
			ease: "none"
			//ease: "bounce"
		})




		heroAnimation.fromTo(".hero__title .word .char", {
			yPercent: 50,
			opacity: 0
			
		},{
			opacity: 1,
			duration: 0.5,
			yPercent: 0,
			stagger: 0.02,
		})

		heroAnimation.fromTo(".hero__subtitle .word .char", {
			yPercent: 50,
			opacity: 0
			
		},{
			opacity: 1,
			duration: 0.2,
			yPercent: 0,
			stagger: 0.01,
		}, "<")

		heroAnimation.fromTo(".hero__bg", {
			background:  "rgba(4, 27, 39, 1)"
			
		},{
			background:  "rgba(4, 27, 39, .4)",
			duration: 0.5,
		})


		heroAnimation.fromTo(".hero__links", {
			opacity: 0
			
		},{
			opacity: 1,
		})

		heroAnimation.fromTo(".headerblock", {
			duration: .2,
			opacity: 0
			
		},{
			opacity: 1,
		}, "<")

		heroAnimation.to(".loader", {
			display:"none",
		})



		gsap.utils.toArray('.location__image img').forEach((image, i) => {
			// Установка начального состояния с увеличенным масштабом и скрытием через clip-path
			gsap.set(image, {
			    autoAlpha: 0,
			    scale: 1.2,
			    clipPath: "inset(0 100% 0 0)" // Скрываем изображение, устанавливая его ширину в 0%
			});
		    
			// Анимация при прокрутке
			gsap.to(image, {
			    scrollTrigger: {
				trigger: '.location',
				start: 'top 50%', // Небольшая задержка для более плавного появления
				end: 'bottom 50% ',
				toggleActions: 'play reverse play reverse',
				// markers: true

			    },
			    autoAlpha: 1, // Полная видимость
			    scale: 1, // Возвращение к нормальному размеру
			    clipPath: "inset(0 0% 0 0)", // Полное отображение изображения
			    duration: 2, // Продолжительность анимации
			    ease: Power4.easeOut, // Эффект плавности
			    delay: i * 0.1, // Задержка между анимациями каждого изображения для последовательного эффекта
			});
		    });

		    gsap.utils.toArray('.gallery__img img').forEach((image2, i) => {
			// Установка начального состояния с увеличенным масштабом и скрытием через clip-path
			gsap.set(image2, {
			    autoAlpha: 0,
			    scale: 1.2,
			    clipPath: "inset(0 100% 0 0)" // Скрываем изображение, устанавливая его ширину в 0%
			});
		    
			// Анимация при прокрутке
			gsap.to(image2, {
			    scrollTrigger: {
				trigger: '.gallery',
				start: 'top 50%', // Небольшая задержка для более плавного появления
				end: 'bottom 50%',
				toggleActions: 'play reverse play reverse',

			    },
			    autoAlpha: 1, // Полная видимость
			    scale: 1, // Возвращение к нормальному размеру
			    clipPath: "inset(0 0% 0 0)", // Полное отображение изображения
			    duration: 2, // Продолжительность анимации
			    ease: Power4.easeOut, // Эффект плавности
			    delay: i * 0.1, // Задержка между анимациями каждого изображения для последовательного эффекта
			});
		    });
				
	}
})


svg4everybody();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;


